// shared history object for use in react-router
import createBrowserHistory from 'history/createBrowserHistory';

const appHistory = createBrowserHistory();
export default appHistory;
